export function ToFa(value: any) {
    const persionDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
    return value.toString().replace(/\d/g, (x: any) => persionDigits[Number(x)]);
}

export function ToEn(value: any) {
    let str = value.replace(',', '');
    const persionDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
    for (var i = 0; i < 10; i++) {
        str = str.replaceAll(persionDigits[i], i);
    }
    return str;
}

export function faNumToEnNum(value: any) {
    let str = value.replace(',', '');
    const persianDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
    for (let i = 0; i < 10; i++) {
        str = str.replaceAll(persianDigits[i], i);
    }
    return str;
}

/**
 * تبدیل ارقام فارسی (۰-۹) و عربی (٠-٩) به ارقام انگلیسی.
 * برخلاف ToEn، هم ارقام عربی را پوشش می‌دهد و هم روی ورودی غیررشته‌ای امن است.
 */
export function toEnDigits(value: any): string {
    if (value === null || value === undefined) return '';
    return value
        .toString()
        .replace(/[۰-۹]/g, (d: string) => String(d.charCodeAt(0) - 0x06f0))
        .replace(/[٠-٩]/g, (d: string) => String(d.charCodeAt(0) - 0x0660));
}

/** فقط ارقام انگلیسی را نگه می‌دارد (برای کد تایید، شبا، کارت و ...). */
export function onlyEnDigits(value: any, maxLength?: number): string {
    const digits = toEnDigits(value).replace(/\D/g, '');
    return maxLength ? digits.slice(0, maxLength) : digits;
}

/**
 * نرمال‌سازی شماره موبایل: ارقام فارسی/عربی به انگلیسی، حذف فاصله و خط تیره،
 * تبدیل +98 / 0098 / 98 به 0، و افزودن صفر ابتدایی به شماره‌های ۹۱۲... .
 */
export function normalizePhoneNumber(value: any): string {
    let digits = toEnDigits(value).replace(/[^\d+]/g, '');
    digits = digits.replace(/^\+?0{0,2}98(?=9)/, '0').replace(/\D/g, '');
    if (digits.startsWith('9')) digits = '0' + digits;
    return digits.slice(0, 11);
}

export function deleteCommaSperator(value: any): any {
    return value.toString().replaceAll(',', '');
}

export function changeDecimal(value: string, decimalNumber: number): any {
    let wholeNum = value.toString().split('.')[0];
    let decimalNum = value.toString().split('.')[1];
    // check has extra decimalNum
    if (!decimalNum || (decimalNumber && decimalNum.length < decimalNumber)) return value;

    if (decimalNumber !== 0) {
        decimalNum = decimalNum.substring(0, decimalNumber);
        //remove extra zero
        for (let i = decimalNum.length - 1; i < decimalNum.length; i--) {
            if (decimalNum[i] === '0')
                decimalNum = decimalNum.substring(0, i - 1) + decimalNum.substring(i, decimalNum.length);
            else break;
        }

        var changedNum = parseFloat(wholeNum + '.' + decimalNum);

        return changedNum;
    } else return wholeNum;
}

export function digitSperator(value: any): any {
    if (!value || (value && value === 0)) return value;
    var str = value.toString().split('.');
    if (str[0].length >= 4) {
        str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, '$1,');
    }
    if (str[1] && str[1].length >= 4) {
        str[1] = str[1].replace(/(\d{3})/g, '$1 ');
    }
    return str.join('.').trim().replaceAll(' ', '');
}

export function ToIranCurrency(num: any) {
    var str = num.toString().split('.');
    if (str[0].length >= 4) {
        str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, '$1,');
    }
    if (str[1] && str[1].length >= 4) {
        str[1] = str[1].replace(/(\d{3})/g, '$1 ');
    }
    return str.join('.');
}

export function IsNumericText(value: any) {
    var regex = /^(([0-9]*)|(([0-9]*)\.([0-9]*)))$/;
    if (!regex.test(value)) {
        return false;
    }
    return true;
}

export function IsNumeric(num: any) {
    if (
        num == '.' ||
        num == '' ||
        num == '0' ||
        num == '1' ||
        num == '2' ||
        num == '3' ||
        num == '4' ||
        num == '5' ||
        num == '6' ||
        num == '7' ||
        num == '8' ||
        num == '9'
    ) {
        return true;
    } else return false;
}
